// Redux Action Types
import { SET_TRANSITION_LOCK_SCREEN } from '../actions/types';
// Initial State
const initialState = false;

export default function (state = initialState, action) {
  if (action.type === SET_TRANSITION_LOCK_SCREEN) return action.payload;
  return state;
}
